import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const radioDefaultVariants = {
  "size": "md"
}
const radioCompoundVariants = []

const radioSlotNames = [
  [
    "root",
    "Radio__root"
  ],
  [
    "control",
    "Radio__control"
  ],
  [
    "labelWrapper",
    "Radio__labelWrapper"
  ],
  [
    "label",
    "Radio__label"
  ],
  [
    "description",
    "Radio__description"
  ]
]
const radioSlotFns = /* @__PURE__ */ radioSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, radioDefaultVariants, getSlotCompoundVariant(radioCompoundVariants, slotName))])

const radioFn = memo((props = {}) => {
  return Object.fromEntries(radioSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const radioVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...radioDefaultVariants, ...compact(variants) })

export const radio = /* @__PURE__ */ Object.assign(radioFn, {
  __recipe__: false,
  __name__: 'radio',
  raw: (props) => props,
  variantKeys: radioVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, radioVariantKeys)
  },
  getVariantProps
})